import AiconeLogo from '@/components/config_components/AiconeLogo/AiconeLogo.vue'
import PlatformSwitcher from '@/components/config_components/PlatformSwitcher/PlatformSwitcher.vue';
import axios from 'axios';
import alert_mixin from '@/utils/mixins/alert_mixin';
import {
  LAUNCH_PLATFORM_URL,
  get_headers,
} from '@/utils/system_constants/constant';

const CONFIG_ROUTE_NAMES = new Set([
  'GlobalOverview',
  'ProjectManagement',
  'UserManagement',
  'RolesManagement',
  'EntityConfigs',
  'EntityConfigDetail',
  'EntitySubsystemBindings',
  'CreateForm',
  'CreateSections',
  'ManageQuestions',
  'PreviewForm',
  'ViewTemplate',
  'UploadTemplate',
  'DocumentsWorkflow',
  'CreateWorkflow',
  'ConfigureWorkflow',
  'ManageDocuments',
  'ManageSubEntities',
  'SubEntityRequirements',
  'ManageStatus',
  'ComplianceManagement',
  'VerificationServices',
  'CreateRiskFramework',
  'ConfigureVerificationServices',
  'ConfigureVerificationForm',
  'VerificationForm',
  'FormQuestionMapping',
  'ManualVerification',
  'ManualVerificationBinding'
]);

export default {
  name: 'ConfigNavbar',
  mixins: [alert_mixin],
  components: { AiconeLogo, PlatformSwitcher },
  props: {
    hide_hamburger: {
      type: Boolean,
      default: false
    },
    is_full_width: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    user_name() {
      return this.$store.getters.currentLeadName || '';
    },
    role() {
      return (
        this.$store.getters.currentRole
        || sessionStorage.getItem('current_role')
        || sessionStorage.getItem('user_role')
        || ''
      );
    },
    is_admin_role() {
      const normalized_role = String(this.role || '').trim().toLowerCase();
      return normalized_role.includes('admin') || normalized_role.includes('administrator');
    },
    show_system_switch() {
      return this.is_admin_role && this.is_config_area;
    },
    is_config_area() {
      return CONFIG_ROUTE_NAMES.has(this.$route?.name);
    },
    system_switch_icon() {
      return this.is_config_area ? 'bi-grid-3x3-gap' : 'bi-sliders';
    },
    system_switch_aria_label() {
      return this.is_config_area ? 'Open X-Verdict workspace' : 'Open Configuration';
    },
    system_switch_route() {
      if (!this.is_config_area) {
        const global_overview_route = { name: 'GlobalOverview', query: this.current_project_query };
        return global_overview_route;
      }

      const workspace_route = {
        name: this.default_workspace_route_name,
        query: this.current_project_query
      };
      return workspace_route;
    },
    default_workspace_route_name() {
      const normalized_role = String(this.role || '').trim().toLowerCase();

      if (
        normalized_role.includes('case owner')
        || normalized_role.includes('case_owner')
        || normalized_role === 'owner'
        || normalized_role.endsWith(' owner')
      ) {
        return 'OwnerDashboard';
      }

      if (
        normalized_role.includes('entity')
        || normalized_role.includes('requestor')
        || normalized_role.includes('requester')
        || normalized_role === 'requestor'
        || normalized_role === 'requester'
      ) {
        return 'RequestorDashboard';
      }

      if (
        normalized_role.includes('intake officer')
        || normalized_role.includes('intake_officer')
        || normalized_role.includes('intake desk')
        || normalized_role === 'intake'
      ) {
        return 'IntakeDesk';
      }

      if (
        normalized_role.includes('coordinator')
        || normalized_role === 'coord'
      ) {
        return 'ScopeDashboard';
      }

      return 'CompanyPortfolio';
    },
    current_project_query() {
      const project_id = this.$route?.query?.project_id;
      return project_id ? { project_id } : {};
    },
    user_initials() {
      return this.user_name
        .split(' ')
        .filter(Boolean)
        .map((part) => part[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();
    }
  },
  methods: {
    async go_to_system_switch() {
      if (!this.show_system_switch) return;

      if (!this.is_config_area) {
        await this.launch_platform('config');
        return;
      }

      if (!this.$router.hasRoute?.(this.system_switch_route.name)) {
        return;
      }

      this.$router.push(this.system_switch_route);
    },
    async launch_platform(platform) {
      const external_user_id = sessionStorage.getItem('user_id')
        || sessionStorage.getItem('current_user_id');

      try {
        const response = await axios.post(
          LAUNCH_PLATFORM_URL,
          { platform, external_user_id },
          { headers: get_headers() }
        );
        const response_data = response.data || {};

        if (response_data.redirect_url) {
          window.location.href = response_data.redirect_url;
          return;
        }

        this.show_error('Failed to launch platform: No redirect URL provided');
      } catch (error) {
        if (error.response?.status === 403) {
          this.show_error('Access denied to this platform');
        } else if (error.response?.status === 404) {
          this.show_error('Platform not found or unavailable');
        } else {
          this.show_error('Failed to launch platform');
        }
      }
    },
  }
}
